import React, { useContext, useEffect, useState } from "react";
import dateCalimg from "../../assets/iposub/dateCal.svg";
import downloadImg from "../../assets/iposub/downloadArrow.svg";
import investmentimg from "../../assets/iposub/investimg.svg";
import lifeinsurancelic from "../../assets/life-insurance-lic--250x250.svg";
import BackButton from "../../components/common/BackButton";
import { useNotificationActionsContext } from "../../components/notificationModal/useModal";
import { Context } from "../../services/apiContext";
import "./css/IPODetails.css";

const IPODetails = ({ nextStep, prevStep, ipoDetailsname, goToPage }) => {
  const contextapi = useContext(Context);
  const setNotifi = useNotificationActionsContext();
  const [ipoDetails, setIpoDetails] = useState({});
  const [isDataloaded, setIsDataloaded] = useState(false);

  useEffect(() => {
  
    getIPOdetails();
  }, []);

  //API LISTING
  const getIPOdetails = async () => {
    var useData = contextapi.getSession("userData").user_key;

    var postData = {
      symbol: ipoDetailsname,
      user_key: useData,
    };
    var url = "/nse/getipodetails";
    await contextapi
      .postApiAuthCalling(url, postData, true)
      .then((res) => {
        console.log(res);
        if (res[0].status_code === "00") {
          setIpoDetails(res[0].IPODetails[0]);
         

         
          setIsDataloaded(true);
        } else {
          setNotifi({ val: true, msg: `Error: ${res[0].status_desc}` });
        }
      })
      .catch((error) => {
        console.log(error);
        // setNotifi({ val: true, msg: "Something went wrong" });
      });
  };




  const stepBack = () => {
    prevStep();
  };
  const goToPageInnerFunc = () => {
    console.log(ipoDetails)
    goToPage(7,ipoDetails);

  };
  return (
    <>
      {isDataloaded && (
        <div>
          <div className="col-lg-12 col-md-12 col-12 addmargin">
            <h5 className="transactionheader">IPO Details</h5>
            <p className="transactionheader_desc">
              The following content shows the details of an IPO
            </p>

             <BackButton />
          </div>

          <div className="IPOCard-List">
            <div className="row makerel">
              <div className="row ">
                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 paddingzeroipodetails">
                  <div className="newFlexItems">
                    <div className="innerImageDiveView_new cursorPointer">
                      {ipoDetails.ipotime == "new" && (
                        <div className="postionbadge">
                          <div className="badgearrow">New</div>
                        </div>
                      )}

                      <img
                        src={lifeinsurancelic}
                        alt="lifeinsu"
                        className="IPOImg"
                      />
                    </div>

                    <div className="makeitmiddlealign_new">
                      <p className="ipoNameValue">{ipoDetails.Name}</p>
                      <p className="ipodateRange">
                        {ipoDetails.BiddingStartDate.split(",")[0]}-
                        {ipoDetails.BiddingEndDate.split(",")[0]}
                      </p>
                    </div>

                    <div className="makeitmiddlealignmore_new">
                      <div
                        className={`ipostatus algincenter mobltop ${
                          ipoDetails.OpenStatus === "O"
                            ? "clrgreen"
                            : ipoDetails.OpenStatus === "C"
                            ? "clrorange"
                            : ipoDetails.OpenStatus === "U"
                            ? "lightred"
                            : ""
                        }`}
                      >
                        {ipoDetails.OpenStatus === "O"
                          ? "Open"
                          : ipoDetails.OpenStatus === "C"
                          ? "Closed"
                          : ipoDetails.OpenStatus === "U"
                          ? "Upcoming"
                          : ""}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 paddingzeroipodetails">
                  <div className="newFlexItems">
                    <div className="  algincenter secondpartFlexfirst_details">
                      <p className="ipoNameValue">Lot size</p>
                      <p className="ipodateRange">{ipoDetails.LotSize}</p>
                    </div>

                    <div className=" algincenter  secondpartFlexsecond_details">
                      <p className="ipoNameValue">Price Range</p>
                      <p className="ipodateRange">
                        {" "}
                          ₹ {ipoDetails.MinPrice}-{ipoDetails.MaxPrice}
                      </p>
                    </div>

                    <div className="secondpartFlexthirdIPODeails">
                      { ipoDetails.OpenStatus === "O" &&
                        <div className=" algincenter">
                          <button
                            className="ipo-list-placeorder"
                            onClick={() => goToPageInnerFunc()}
                          >
                            APPLY NOW
                          </button>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div className="IPO_details_IndividuaCard">
                <div className="row ">
                  <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
                    <div className="ipoINdetails">
                      <img
                        src={investmentimg}
                        className="investClassname"
                        alt="img"
                      />
                      <div className="ipoNextDesc">
                        <p className="lableBold">Minimum Investment</p>
                        <p className="valuelight">
                          ₹ {ipoDetails.MinPrice * ipoDetails.LotSize}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
                    <div className="ipoINdetails">
                      <img
                        src={dateCalimg}
                        className="investClassname"
                        alt="img"
                      />
                      <div className="ipoNextDesc">
                        <p className="lableBold">IPO Open Date</p>
                        <p className="valuelight">
                          {ipoDetails.BiddingStartDate}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
                    <div className="ipoINdetails">
                      <img
                        src={dateCalimg}
                        className="investClassname"
                        alt="img"
                      />
                      <div className="ipoNextDesc">
                        <p className="lableBold">IPO Close Date</p>
                        <p className="valuelight">
                          {ipoDetails.BiddingEndDate}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
                    <div className="ipoINdetails">
                      <button className="btnImgall">
                        <img src={downloadImg} alt="downlimg" />
                        DOWNLOAD REPORT
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 paddingzeroipodetails">
                <div className="individualBoxCss marginDetaright">
                  <p className="iposteps">Apply for IPO in 3 steps.</p>

                  <div className="stepsFlex">
                    <div className="numberdiv">
                      <p>1</p>
                    </div>
                    <div className="ipostessecondflex">
                      <p>
                        After selection of an IPO, enter your bid details
                        (quantity, price & no. of bids)
                      </p>
                    </div>
                  </div>

                  <div className="stepsFlex">
                    <div className="numberdiv">
                      <p>2</p>
                    </div>
                    <div className="ipostessecondflex">
                      <p>
                        Review and Place the order which will "Block Funds" on
                        UPI.
                      </p>
                    </div>
                  </div>

                  <div className="stepsFlex">
                    <div className="numberdiv">
                      <p>3</p>
                    </div>
                    <div className="ipostessecondflex">
                      <p>
                        If allotted, final amount will be debited, otherwise it
                        will be unblocked
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 paddingzeroipodetails">
                <div className="individualBoxCss marginDetaleft">
                  <p className="ipostepsDates">Dates.</p>

                  <div className="stepsFlexTable oddcolor">
                    <p className="datesTableLable">IPO Close</p>
                    <p className="datesTablevalue">{ipoDetails.BiddingEndDate}</p>
                  </div>

                  <div className="stepsFlexTable ">
                    <p className="datesTableLable">Allotment finalization</p>
                    <p className="datesTablevalue">{ipoDetails.finalization_date}</p>
                  </div>

                  <div className="stepsFlexTable oddcolor">
                    <p className="datesTableLable">Refund Initiation</p>
                    <p className="datesTablevalue">{ipoDetails.refund_date}</p>
                  </div>

                  <div className="stepsFlexTable ">
                    <p className="datesTableLable">Listing</p>
                    <p className="datesTablevalue">{ipoDetails.listing_date}</p>
                  </div>
                </div>
              </div>

              { ipoDetails.OpenStatus === "O" && <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div className=" algincenter btnMargin">
                  <button
                    className="applyMainBTn"
                    onClick={() => goToPageInnerFunc()}
                  >
                    APPLY NOW
                  </button>
                </div>
              </div>}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default IPODetails;
